import store from '../store'

export default async (to, from, next) => {
  // Se não está logado e não é página pública
  if (to.name !== 'login' && to.name !== 'confirmation' && to.name !== 'sso' && !store.getters['auth/hasToken']) {
    try {
      await store.dispatch('auth/ActionCheckToken')
      next({ path: to.path })
    } catch (err) {
      next({ name: 'login' })
    }
    return
  }

  // Se está na página de login mas já tem token
  if (to.name === 'login' && store.getters['auth/hasToken']) {
    next({ name: 'home' })
    return
  }

  // Carrega configurações RSVP se estiver autenticado
  if (store.getters['auth/hasToken'] && to.name !== 'login' && to.name !== 'confirmation') {
    const hasRsvpData = store.state.settingRSVP &&
                        store.state.settingRSVP.settingRSVP &&
                        Object.keys(store.state.settingRSVP.settingRSVP).length > 0

    if (!hasRsvpData) {
      try {
        await store.dispatch('settingRSVP/GetRSVP')
      } catch (err) {
        // Se falhar, apenas continua sem bloquear a navegação
        console.warn('Failed to load RSVP settings:', err)
      }
    }
  }

  // Verificação de roles (desabilitada temporariamente - usar sistema de permissões)
  // if (to.meta && to.meta.roles && to.meta.roles.length > 0 && !to.meta.roles.includes(store.getters['auth/userRole'])) {
  //   next({ name: 'unauthorized' })
  //   return
  // }

  next()
}
